module.exports = __webpack_public_path__ + "f50429374817271f1bc01e7771df949c.png";